// src/auth/index.js

import Vue from 'vue'

import config from 'conf'
import { event } from 'utils'
import { setCookie, removeCookie } from 'utils/cookies'

export default {
  user: {
    authenticated: false,
  },

  // Login request to the server
  login(context, creds, redirect) {
    const self = this

    $('.btn-submit').buttonLoader('start')

    // this.checkAuth(context,localStorage.getItem('afripodsLoggedInAccountType'))

    context.$http.post(config.url.login, creds).then(
      (response) => {
        $('.btn-submit').buttonLoader('stop')

        const { token } = response.body.data

        if (token !== '' && token !== null) {
          self.user.authenticated = true
          localStorage.setItem('afripodsToken', token)
          setCookie('legacyToken', token)
          self.getUserProfile(context, redirect)
        }

        document.getElementById('loginModal').remove()
        document.getElementsByClassName('modal-backdrop')[0].remove()
      },
      (error) => {
        $('.btn-submit').buttonLoader('stop')
        Vue.notify({
          title: 'Authentication Error',
          text: Vue.prototype.getErrorMessage(error),
          type: 'error',
        })
      }
    )
  },
  loginAsUser(context, id, redirect) {
    const self = this

    context.$http
      .get(`${config.url.login_as_user}/${id}`, {
        params: {},
        headers: this.getAuthHeader(),
      })
      .then(
        (response) => {
          const { token } = response.body.data

          if (token !== '' && token !== null) {
            self.user.authenticated = true
            localStorage.setItem('afripodsToken', token)
            setCookie('legacyToken', token)
            self.getUserProfile(context, redirect)
          }
        },
        () => {
          Vue.notify({
            title: 'Login as user failed',
            type: 'error',
          })
        }
      )
  },
  getUserProfile(context, redirect) {
    context.$http
      .get(config.url.user, {
        params: {},
        headers: this.getAuthHeader(),
      })
      .then(
        (response) => {
          localStorage.setItem('afripodsLoggedInUserId', response.body.data.id)
          localStorage.setItem('afripodsLoggedInUserName', response.body.data.name)
          localStorage.setItem('afripodsLoggedInUserImage', response.body.data.image)
          localStorage.setItem('afripodsLoggedInUserEmail', response.body.data.email)
          localStorage.setItem('afripodsLoggedInAccountType', response.body.data.type)
          localStorage.setItem('afripodsLoggedInUserHasPodcasts', response.body.data.has_podcast)

          const { ...userInfo } = response.body.data
          setCookie('userInfo', userInfo)

          event.$emit('setLoggedInUserInfo')
          let redirectPath = ''
          const accountType = response.body.data.type

          if (accountType === 'admin') {
            redirectPath = '/admin/podcasts'
          } else if (accountType === 'podcaster') {
            if (redirect === '' || !response.body.data.has_podcast) {
              redirectPath = ''
              event.$emit('setLoggedInUserInfo')
            } else {
              redirectPath = '/podcaster/dashboard'
            }
          } else if (accountType === 'advertiser') {
            redirectPath = '/advertiser/dashboard'
          } else if (accountType === 'listener') {
            redirectPath = '/'
          }

          context.$router.push({ path: redirectPath })
        },
        () => {}
      )
  },

  // Password retrieve request to the server
  retrievePassword(context, creds) {
    $('.btn-submit').buttonLoader('start')

    context.$http.post(`${config.url.password_recover}?email=${creds.email}`).then(
      () => {
        $('.btn-submit').buttonLoader('stop')

        Vue.notify({
          title: 'Request Sent',
          text: 'Password reset request has been sent to your email address.',
          type: 'success',
        })

        $('#retrieve-password-form')[0].reset()
      },
      (error) => {
        $('.btn-submit').buttonLoader('stop')

        Vue.notify({
          title: 'Response Error',
          text: Vue.prototype.getErrorMessage(error),
          type: 'error',
        })
      }
    )
  },

  // Reset password
  resetPassword(context, creds) {
    $('.btn-submit').buttonLoader('start')

    context.$http
      .post(
        `${config.url.password_reset}?user_id=${creds.user_id}&recovery_key=${creds.recovery_key}&password=${creds.password}`
      )
      .then(
        () => {
          $('.btn-submit').buttonLoader('stop')

          Vue.notify({
            title: 'Password Changed',
            text: 'Your account password has been changed. You can now login to your account with your new chosen password',
            type: 'success',
          })
          document.getElementById('retrievePasswordModal').remove()
          document.getElementsByClassName('modal-backdrop')[0].remove()
          $('#password-reset-form')[0].reset()
        },
        (error) => {
          $('.btn-submit').buttonLoader('stop')

          Vue.notify({
            title: 'Response Error',
            text: Vue.prototype.getErrorMessage(error),
            type: 'error',
          })
        }
      )
  },

  // Logout user
  logout() {
    this.user.authenticated = false
    localStorage.removeItem('afripodsToken')
    localStorage.removeItem('afripodsLoggedInUserId')
    localStorage.removeItem('afripodsLoggedInUserName')
    localStorage.removeItem('afripodsLoggedInUserPodcasts')
    localStorage.removeItem('afripodsLoggedInUserImage')
    localStorage.removeItem('afripodsLoggedInUserEmail')
    localStorage.removeItem('afripodsLoggedInAccountType')
    localStorage.removeItem('userShows')
    localStorage.removeItem('userBookmarks')

    // Clear auth cookies used by new frontend
    removeCookie('legacyToken')
    removeCookie('userInfo')

    event.$emit('logOutUser')
  },

  getLoggedInUserId() {
    return localStorage.getItem('afripodsLoggedInUserId')
  },

  checkToken() {
    const token = localStorage.getItem('afripodsToken')
    const accountType = localStorage.getItem('afripodsLoggedInAccountType')

    return !!(token != null || accountType != null)
  },

  // Check user logged in
  checkAuth(context, type) {
    const token = localStorage.getItem('afripodsToken')
    const accountType = localStorage.getItem('afripodsLoggedInAccountType')

    if (token !== '' && accountType !== type) {
      this.logout()
      context.$router.push({ path: '/home' })
    } else {
      setTimeout(() => {
        event.$emit('setLoggedInUserInfo')
      }, 200)
    }
  },

  checkAuthentication(type) {
    const token = localStorage.getItem('afripodsToken')
    const accountType = localStorage.getItem('afripodsLoggedInAccountType')

    return token && accountType === type
  },

  // The object to be passed as a header for authenticated requests
  getAuthHeader() {
    return {
      Authorization: `Bearer ${localStorage.getItem('afripodsToken')}`,
    }
  },
}



// WEBPACK FOOTER //
// ./src/auth/index.js